import React, { useEffect, useState } from 'react';
import { useCloseOnEscape } from '../../../hooks/useCloseOnEscape';
import menuCloseIcon from '../../icons/figma/home-mobile/menu-close.svg';
import arrowDownIcon from '../../icons/figma/settings-mobile/arrow-down.svg';
import VenueMobileHeader from './VenueMobileHeader';
import './SettingsMobile.css';

const CATEGORIES = [
  { id: 'account-settings', label: 'Account settings' },
  { id: 'venue-details', label: 'Venue details' },
  { id: 'operating-hours', label: 'Operating hours and holidays' },
  { id: 'calendar-sync', label: 'Calendar sync' },
  { id: 'pricing-controls', label: 'Pricing controls' },
  { id: 'payments', label: 'Payments' }
];

const SettingsMobileChrome = ({
  activeSubSection,
  onSubSectionChange,
  onSectionChange,
  showPayments = false
}) => {
  const [sheetOpen, setSheetOpen] = useState(false);

  const categories = showPayments ? CATEGORIES : CATEGORIES.filter((item) => item.id !== 'payments');
  const current = categories.find((item) => item.id === activeSubSection) || categories[0];

  const closeSheet = () => setSheetOpen(false);
  useCloseOnEscape(sheetOpen, closeSheet);

  useEffect(() => {
    if (!sheetOpen) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, [sheetOpen]);

  return (
    <div className="settings-mobile">
      <VenueMobileHeader
        activeSection="settings"
        onSectionChange={onSectionChange}
        onBeforeOpen={closeSheet}
      />
      <button
        type="button"
        className="settings-mobile-category"
        aria-expanded={sheetOpen}
        aria-haspopup="dialog"
        onClick={() => setSheetOpen(true)}
      >
        <span>{current.label}</span>
        <img src={arrowDownIcon} alt="" width="20" height="20" />
      </button>

      {sheetOpen ? (
        <div className="settings-mobile-overlay settings-mobile-overlay--sheet" onClick={closeSheet}>
          <div
            className="settings-category-sheet"
            role="dialog"
            aria-modal="true"
            aria-labelledby="settings-category-title"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="settings-category-header">
              <h2 id="settings-category-title">Select category</h2>
              <button type="button" className="settings-mobile-icon" aria-label="Close" onClick={closeSheet}>
                <img src={menuCloseIcon} alt="" width="20" height="20" />
              </button>
            </div>
            <div className="settings-category-list">
              {categories.map((item) => {
                const selected = item.id === activeSubSection;
                return (
                  <button
                    key={item.id}
                    type="button"
                    className="settings-category-option"
                    aria-current={selected ? 'true' : undefined}
                    onClick={() => {
                      setSheetOpen(false);
                      if (!selected) onSubSectionChange?.(item.id);
                    }}
                  >
                    <span>{item.label}</span>
                    {selected ? (
                      <em>Current</em>
                    ) : (
                      <img src={arrowDownIcon} alt="" width="16" height="16" className="is-next" />
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default SettingsMobileChrome;
